import * as main from 'components/pages/main/main.js';
import * as text from 'components/pages/text/text.js';
import * as regionSelector from 'components/pages/regionSelector/regionSelector.js';
export { main };
export { text };
export { regionSelector };